<template>
  <div style="height: 100vh; overflow: hidden;">
    <DashboardPlusV3/>
  </div>
</template>

<script>
import baseUrl from "@/base-url.js";
// import NotifyTeacher from "@/views/notifyTeacher/NotifyTeacher.vue";
import DashboardPlusV3 from "../dashboard/DashboardPlusV3.vue";

export default {
  components: {
    DashboardPlusV3,
    // NotifyTeacher

  },
  data(){
    return{
      // test:`asdas`+'\n'+ `adssagefsatger`
      test:false
    }
  },
  created() {
    // const date=this.$funcCommon.formatMY(2023,8)
    // console.log(date)
  },
  methods: {
    handleCloseTemplateDeleteDialog(val){
      this.test= val
    },
    abc() {
      this.test=!this.test
      // this.$store.commit('finance2Module/get_status_excel')
      // alert("test: " + baseUrl.mytest);
    },
    api() {
      alert("api: " + baseUrl.myApi);
    },
  },
};
</script>

<style lang="scss" scoped></style>
